import angular from 'angular';
import FuelForm from './fuel-form/fuel-form.component';
import FuelTable from './fuel-table/fuel-table.component';
import Routes from './fuel.routes';

export default angular.module('autoboard.fuel', [FuelForm, FuelTable])
  .config(Routes)
  .name;
